import {
  Container,
  Duration,
  Category,
  ImageCover,
  ThumbnailImage,
  Title,
  Wrapper,
  InputGroup,
  Label,
  Button,
  Toast,
} from "./CreateBlog.Elements";
import React, { useState, useRef, useMemo, useEffect } from "react";
import JoditEditor from "jodit-react";
import uploadImage from "../../utils/uploadImage";
import { createBlogAPICall } from "../../utils/apiCalls";

const CreateBlog = () => {
  const config = {
    readonly: false,
  };
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [shortDesc, setShortDesc] = useState("");
  const [duration, setDuration] = useState(3);
  const [category, setCategory] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [thumbnailURL, setThumbnailURL] = useState(null);
  const [cover, setCover] = useState("");
  const [coverURL, setCoverURL] = useState(null);
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    // Form Validation
    if (!title) {
      setMessage("title is requied");
      return;
    } else if (!thumbnail) {
      setMessage("thumbnail is requied");
      return;
    } else if (!duration) {
      setMessage("duration is requied");
      return;
    } else if (!category) {
      setMessage("category is requied");
      return;
    } else if (!content) {
      setMessage("content is requied");
      return;
    } else if (!shortDesc) {
      setMessage("short description is requied");
      return;
    }

    // preparing API Call body with blog data
    const blogFeed = {
      title: title,
      thumbnailImage: thumbnailURL,
      imageCover: coverURL,
      duration: duration,
      category: category,
      content: content,
      shortDesc: shortDesc,
    };

    createBlogAPICall(blogFeed, setMessage);
  };

  return (
    <Container>
      <Wrapper>
        <h1 style={{ textAlign: "center", marginTop: "10px" }}>Create Blog</h1>
        {message && <Toast>{message}</Toast>}

        <InputGroup>
          <Label htmlFor='title'>Title:</Label>
          <Title
            id='title'
            type='text'
            placeholder='Title'
            onChange={(e) => setTitle(e.target.value)}
            value={title}
          />
        </InputGroup>

        <InputGroup>
          <Label htmlFor='thumbnail'>Upload Thumbnail:</Label>
          <ThumbnailImage
            id='thumbnail'
            type='file'
            accept='image/png, image/jpeg'
            onChange={(e) => setThumbnail(e.target.files[0])}
          />
          {!thumbnailURL ? (
            <Button onClick={() => uploadImage(thumbnail, setThumbnailURL)}>
              upload
            </Button>
          ) : (
            <span>File uploaded</span>
          )}
        </InputGroup>

        <InputGroup>
          <Label htmlFor='cover'>Upload Cover:</Label>
          <ImageCover
            id='cover'
            type='file'
            accept='image/png, image/jpeg'
            onChange={(e) => setCover(e.target.files[0])}
          />
          {!coverURL ? (
            <Button onClick={() => uploadImage(cover, setCoverURL)}>
              upload
            </Button>
          ) : (
            <span>File uploaded</span>
          )}
        </InputGroup>

        <InputGroup>
          <Label htmlFor='duration'>Duration:</Label>
          <Duration
            id='duration'
            type='Number'
            onChange={(e) => setDuration(e.target.value)}
            value={duration}
          />
        </InputGroup>

        <InputGroup>
          <Label htmlFor='category'>Category:</Label>
          <Category
            id='category'
            type='text'
            placeholder='Category'
            onChange={(e) => setCategory(e.target.value)}
            value={category}
          />
        </InputGroup>

        <InputGroup>
          <Label htmlFor='short'>Short Description:</Label>
          <Title
            id='short'
            type='text'
            placeholder='Short Description'
            onChange={(e) => setShortDesc(e.target.value)}
            value={shortDesc}
          />
        </InputGroup>

        <InputGroup>
          <Label>Content:</Label>
          <JoditEditor
            ref={editor}
            value={content}
            config={config}
            tabIndex={1} // tabIndex of textarea
            onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
            onChange={(newContent) => {}}
          />
        </InputGroup>

        <InputGroup>
          <Button onClick={handleSubmit}>Submit</Button>
        </InputGroup>
      </Wrapper>
    </Container>
  );
};

export default CreateBlog;
